<p-dialog
    header="Change Password"
    [visible]="visible()"
    (visibleChange)="visibleChange.emit($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [appendTo]="'body'"
    [style]="{ width: '460px' }"
    styleClass="change-password-dialog"
>

    <div class="dialog-content">

        <div class="dialog-description">
            Enter a new password.
        </div>


        <!-- New password -->

        <div class="dialog-field">

            <label for="new-password">
                New password
            </label>

            <input
                id="new-password"
                type="password"
                pInputText
                class="w-full"
                [(ngModel)]="password"
                autocomplete="new-password"
            />

        </div>


        <!-- Confirm password -->

        <div class="dialog-field">

            <label for="confirm-password">
                Confirm password
            </label>

            <input
                id="confirm-password"
                type="password"
                pInputText
                class="w-full"
                [(ngModel)]="passwordConfirm"
                autocomplete="new-password"
            />

            @if (hasMismatch()) {

                <small class="password-error">
                    Passwords do not match.
                </small>

            }

        </div>


        <div class="password-hint">
            Password must contain at least 8 characters.
        </div>

    </div>


    <ng-template #footer>

        <button
            pButton
            type="button"
            severity="secondary"
            label="Cancel"
            (click)="close()">
        </button>


        <p-button
            type="button"
            label="Change Password"
            icon="pi pi-key"
            [disabled]="!isValid()"
            (onClick)="changePassword()">
        </p-button>

    </ng-template>

</p-dialog>